export default {
  tags: {
    default: 'Oletus',
    visible_to: 'Näkyy käyttäjille',
    not_visible_to: 'Ei näy käyttäjille',
  },
  labels: {
    inclusive: 'Sisältää',
    exclusive: 'Ei sisällä',
    public: 'Julkinen',
  },
  buttons: {
    edit: 'Muokkaa',
    delete: 'Poista',
  },
};
